var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.877441L4.25 4.96869V14.8649C4.2527 16.7964 4.71092 18.7 5.58746 20.4212C6.46399 22.1423 7.73412 23.6325 9.29469 24.7706L15.5 29.2837L21.7053 24.7706C23.2659 23.6325 24.536 22.1423 25.4125 20.4212C26.2891 18.7 26.7473 16.7964 26.75 14.8649V4.96869L15.5 0.877441ZM24.875 14.8649C24.8724 16.5007 24.4842 18.1129 23.7419 19.5706C22.9997 21.0282 21.9242 22.2904 20.6028 23.2546L15.5 26.9662L10.3972 23.2546C9.0758 22.2904 8.00033 21.0282 7.25805 19.5706C6.51577 18.1129 6.12759 16.5007 6.125 14.8649V6.28119L15.5 2.87244L24.875 6.28119V14.8649Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4753 12.6963L10.1497 14.0219L14.3281 18.2004L20.8503 11.6782L19.5247 10.3525L14.3281 15.5491L11.4753 12.6963Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.ca2be7b04a32e3753cff52ae2538b5e2.svg";
export { ForwardRef as ReactComponent };